import { ElectronApi } from '@/services/electron.api';
import JSZip from 'jszip';
import { isDirectory, isFile } from './fs-extra.utils';

export const pickZipExtensions = ['mwz', 'zip'];
/**
 * 打包目录,返回打包后的ArrayBuffer或blob
 */
export async function zipDir(
  dir: string,
  type?: 'arraybuffer' | 'blob',
  validFn?: (filename: string) => boolean
) {
  const zip = new JSZip();
  const fs = ElectronApi.fs;
  const path = ElectronApi.path;
  if (!fs || !path) return;
  try {
    const _zipDir = async (dir: string, zip: JSZip) => {
      const files = await fs.promises.readdir(dir);
      for (const _file of files) {
        const file = path.join(dir, _file);
        if (validFn && !validFn?.(file)) {
          // console.log('忽略', file);
          continue;
        }
        if (await isFile(file)) {
          const content = await fs.promises.readFile(file);
          zip.file(_file, content.buffer);
        }
        if (await isDirectory(file)) {
          const _zip = zip.folder(_file);
          if (_zip) {
            await _zipDir(file, _zip);
          }
        }
      }
    };

    await _zipDir(dir, zip);
    const res = await zip.generateAsync({
      type: type ?? 'arraybuffer',
      compression: 'DEFLATE'
    });
    return res;
  } catch (error) {
    console.log(error);
  }
}

/**
 * 解压，解压完成之后返回解压目录
 */
export const unZip = async (zipPath: string | undefined) => {
  const fs = ElectronApi.fs;
  const path = ElectronApi.path;
  if (!fs || !path || !zipPath) return;

  // 获取压缩包的所有文件
  const _getZipFiles = async (zipUrl: string) => {
    const response = fs.readFileSync(zipUrl);
    // loadAsync加载其他类型资源会出问题，比如资源乱码
    const zipData = await JSZip.loadAsync(response);
    return zipData.files;
  };

  // 将压缩包的文件写入文件夹
  const _saveZipFiles = async (
    files: { [key: string]: JSZip.JSZipObject },
    savePath: string
  ) => {
    // 获取解压后的文件
    if (!files) return;
    try {
      for (const filename of Object.keys(files)) {
        const dest = path.join(savePath, filename);
        // 如果该文件为目录需先创建文件夹
        if (files[filename].dir && !(await isDirectory(dest))) {
          fs.mkdirSync(dest, {
            recursive: true
          });
        } else {
          // 把每个文件buffer写到硬盘中
          files[filename]
            .async('arraybuffer')
            .then((content) => fs.writeFileSync(dest, Buffer.from(content)));
        }
      }
    } catch (error) {
      console.error('save zip files encountered error!', error);
      return error;
    }
  };

  const _createTargetDir = (zipUrl: string) => {
    const baseDir = path.dirname(zipUrl);
    const reg = new RegExp(`.(${pickZipExtensions.join('|')})$`);
    const dirname = path.basename(zipUrl).replace(reg, '');

    let count = 0;
    let dir = path.join(baseDir, dirname);
    while (fs.existsSync(dir)) {
      dir = path.join(baseDir, `${dirname}_${count}`);
      count++;
    }
    fs.mkdirSync(dir);
    return dir;
  };

  const to = _createTargetDir(zipPath);
  const files = await _getZipFiles(zipPath);
  await _saveZipFiles(files, to);
  return to;
};
